import styled from 'styled-components';

export default styled.div`
  div.wrapper {
    margin: 26px auto;
    color: ${props =>
      props.type === 'error'
        ? props.theme.colors.error.color
        : props.theme.colors.success.color};
    span {
      font-weight: 800;
      font-size: 24px;
    }

    svg {
      display: block;
      height: 48px;
      margin: 4px auto 25px auto;
    }

    p {
      margin-top: 24px;
      max-width: 220px;
      margin-left: auto;
      margin-right: auto;
      line-height: 1.5;

      .support-line {
        color: #182445;
      }
    }

    button {
      color: ${props =>
        props.type === 'error'
          ? props.theme.colors.error.color
          : props.theme.colors.success.color};
      border: 1px solid
        ${props =>
          props.type === 'error'
            ? props.theme.colors.error.color
            : props.theme.colors.success.color};
      width: 150px;
      height: 50px;
      border-radius: 4px;
      line-height: 1.5;
      letter-spacing: 0.4px;
    }
  }
`;
